import React, { useState } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';

import KalturaPlayer from '../../video-player/kaltura';
import YouTubePlayer from '../../video-player/youtube';

const Container = styled.div`
    padding-bottom: 16px;

    & > div:not(:last-child) {
        margin-bottom: 8px;
    }
`;

export const VideoList = styled.div`
    display: flex;
    flex-wrap: wrap;

    & > div:not(:last-child) {
        margin-right: 8px;
    }

    & > div {
        margin-top: 16px;
    }

    @media (max-width: 767px) {
        & > div:not(:nth-child(odd)) {
            margin-right: 0;
        }
    }
`;

const VideoContainer = styled.div`
    width: 192px;

    @media (max-width: 767px) {
        /** 4px sono la metà del margine di destra, in questo modo 2 video occupano tutto lo spazio */
        width: calc(50% - 4px);
    }
`;

const DEFAULT_TITLE = 'Video';
//const SOURCE_YOUTUBE = '1';
const SOURCE_KALTURA = '2';

export const parseVideos = (videos) => {
    const parser = new DOMParser();

    const result = [];

    for (let i = 0; i < videos.length; i++) {
        const currentAnimation = videos[i].xml;
        const document = parser.parseFromString(currentAnimation, 'application/xml');
        const source = document.getElementsByTagName('item')[0].getAttribute('source');
        const parsedPublicTitle = document.getElementsByTagName('public_title')[0];

        let publicTitle;
        if (parsedPublicTitle && parsedPublicTitle.textContent) {
            publicTitle = parsedPublicTitle.textContent;
        } else {
            publicTitle = `${DEFAULT_TITLE} ${i + 1}`;
        }

        const videoId = document.getElementsByTagName('src')[0].textContent;

        result.push({ title: publicTitle, videoId: videoId, source: source });
    }

    return result;
};

const VideoType = ({ videos }) => {
    const [selected, setSelected] = useState(null);
    const parsedVideos = parseVideos(videos);

    const selectedVideo = parsedVideos[selected === null ? 0 : selected];
    const listVideo = parsedVideos.filter((a, i) => {
        if (selected === null) {
            return i !== 0;
        }

        return i !== selected;
    });

    const changeSelected = (videoId) => {
        const nextIndex = parsedVideos.findIndex((v) => v.videoId === videoId);
        setSelected(nextIndex);
    };

    return (
        <Container>
            {selectedVideo.source === SOURCE_KALTURA ? (
                <KalturaPlayer
                    key={selectedVideo.videoId}
                    videoId={selectedVideo.videoId}
                    title={selectedVideo.title}
                    autoPlay={selected !== null}
                />
            ) : (
                <YouTubePlayer
                    key={selectedVideo.videoId}
                    videoIdOrSource={selectedVideo.videoId}
                    showPreview={selected === null}
                    autoPlay={selected !== null}
                />
            )}

            <VideoList>
                {listVideo.map((v) => (
                    <VideoContainer key={`container_${v.videoId}`}>
                        {v.source === SOURCE_KALTURA ? (
                            <KalturaPlayer
                                key={v.videoId}
                                videoId={v.videoId}
                                title={v.title}
                                onPlayVideo={() => changeSelected(v.videoId)}
                            />
                        ) : (
                            <YouTubePlayer
                                key={v.videoId}
                                videoIdOrSource={v.videoId}
                                onPlayVideo={() => changeSelected(v.videoId)}
                                showPreview={true}
                            />
                        )}
                    </VideoContainer>
                ))}
            </VideoList>
        </Container>
    );
};

VideoType.propTypes = {
    videos: PropTypes.array,
};

export default VideoType;
